import { createApiSlice } from '@/shared/features/query/config/query.build';
import type { ReduxQueryClient } from '@/shared/features/query/domain/interfaces/QueryClient';
import type { AppDispatch } from '@/app/store/store';
import { executeQuery } from '@/shared/features/query/utils/queryUtils';
import { getApiBaseUrl } from '@/core/utils/apiUtils';
import type { PdpDeliveryResponseDTO } from '../dto/pdpDelivery.dto';
import { deliveryDtoToDeliveryInfo } from '../mappers/pdpDelivery.mapper';
import type { DeliveryDateRepository } from '../../domain/interfaces/DeliveryDateRepository';
import type { DeliveryInfo } from '../../domain/models/DeliveryInfo';

export type GetDeliveryDateArgs = {
  pincode: string;
  designId: string;
};

const pdpDeliveryApiSlice = createApiSlice({
  clientId: 'pdpDeliveryApi',
  tagTypes: ['PDPDelivery'],
  endpoints: {
    getDeliveryDate: {
      url: (args: unknown) => {
        const { pincode, designId } = (args || {}) as GetDeliveryDateArgs;
        return `${getApiBaseUrl()}/deliverydate/design/get?pincode=${encodeURIComponent(pincode)}&designId=${encodeURIComponent(designId)}`;
      },
      method: 'GET',
      transformResponse: (response: unknown): Record<string, unknown> => {
        const dto = (response ?? {}) as PdpDeliveryResponseDTO;
        return deliveryDtoToDeliveryInfo(dto) as unknown as Record<string, unknown>;
      },
      keepUnusedDataFor: 0,
    },
  },
});

export const pdpDeliveryApi = pdpDeliveryApiSlice.queryClient;
export const pdpDeliveryApiRedux = pdpDeliveryApiSlice.queryClient as ReduxQueryClient;

export class PdpDeliveryAdapter implements DeliveryDateRepository {
  constructor(private readonly dispatch: AppDispatch) {}

  async fetchDeliveryDate(pincode: string, designId: string): Promise<DeliveryInfo> {
    const initiateResult = pdpDeliveryApi.endpoints.getDeliveryDate.initiate({ pincode, designId });
    const plain = await executeQuery<Record<string, unknown>>(initiateResult, this.dispatch);
    return plain as unknown as DeliveryInfo;
  }
}
